module.exports = __webpack_public_path__ + "static/media/minafintech.e67a8710.png";